import { render, staticRenderFns } from "./Treemap.vue?vue&type=template&id=2f539cfa&lang=pug&"
import script from "./Treemap.vue?vue&type=script&lang=ts&"
export * from "./Treemap.vue?vue&type=script&lang=ts&"
import style0 from "./Treemap.vue?vue&type=style&index=0&id=2f539cfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports